// Local component-level state (mini React-like)
const stateList: unknown[] = [];
let cursor = 0;

export function resetCursor(): void {
  cursor = 0;
}

export function useState<T>(initial: T): [T, (value: T | ((prev: T) => T)) => void] {
  const id = cursor++;
  if (stateList[id] === undefined) stateList[id] = initial;

  const setState = (value: T | ((prev: T) => T)): void => {
    stateList[id] = (typeof value === 'function')
      ? (value as (prev: T) => T)(stateList[id] as T)
      : value;

    // Re-render trigger for local components
    document.dispatchEvent(new CustomEvent('local:stateChange'));
  };

  return [stateList[id] as T, setState];
}
